import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import NavigateNextOutlinedIcon from "@mui/icons-material/NavigateNextOutlined";
import { Link } from "react-router-dom";
import no_special from "../../../assests/img/Asset 41.svg";
import sample_date from "../../../assests/img/Asset 35.svg";
import Parameter from "../../../assests/img/Asset 33.svg";
import offer from "../../../assests/img/offer_img.png";
import { useDispatch, useSelector } from "react-redux";
import { homeData } from "../../../redux/HomeSlice";

// const cardDatas = Array.from({ length: 3 }).map((_, i) => ({
//     id: i + 1,
//     title: 'SWASTHFIT SUPER',
//     text1: '12 Hour Fasting Mandatory.',
//     text2: 'Sample Daily by 11 AM; Report Same day',
//     text3: '55 parameter(s) covered',
//     persentage: '50% off',
//     price: '₹1111',
//     oldPrice: '₹1111',
// }));

const PopularTest = () => {
  // const navigation = useNavigate();
  const dispatch = useDispatch();

  const responseHome = useSelector((state) => state.homeReducer.data);

  const [homeData2, setHomeData] = useState(null);

  useEffect(() => {
    dispatch(homeData());
  }, []);

  useEffect(() => {
    console.log("responseHome.data.packages ===>", responseHome);
    if (responseHome != null && responseHome.status === 1) {
      setHomeData(responseHome.data.packages);
    } else if (responseHome != null) {
      console.error("Error fetching home data:", responseHome.message);
    }
  }, [responseHome]);

  return (
    <div className="popular_card_sec">
      <div className="coustom_container">
        <h3>Popular Health Packages</h3>
        {/* <div className="popular_card_sec_text">
          <Link to="#">View All</Link>
        </div> */}
        <Row>
          {homeData2 != null &&
            homeData2.map((item) => (
              <Col lg={4} md={6} sm={12} key={item.id}>
                <Card className="custom-card">
                  <div className="card_title_img">
                    <Card.Title>{item.name}</Card.Title>
                    {/* <Card.Img src={offer} alt='offer' /> */}
                  </div>
                  <Card.Body>
                    {item.description.map((item, index) => (
                      <div className="card_img">
                        <Card.Text>- {item}.</Card.Text>
                      </div>
                    ))}
                    {/* <div className='card_img'>
                                        
                                        <Card.Text>- Sample Daily by 11 AM; Report Same day</Card.Text>
                                    </div>
                                    <div className='card_img'>

                                        <Card.Text>- 55 parameter(s) covered</Card.Text>
                                    </div> */}
                    <div className="buy_now">
                      <div className="buy_now_text">
                        {/* <Card.Text>11111</Card.Text> */}
                        <span>₹{item.amount}</span>
                      </div>
                      <div className="buy_now_offer">
                        <img src={item.image} alt="offer" />
                        {/* <span>50% Off</span> */}
                      </div>
                    </div>
                    <div className="card_btn">
                      <Link
                        to="https://play.google.com/store/search?q=kior+healthcare&c=apps&hl=en"
                        target="_blank"
                      >
                        Buy Now <NavigateNextOutlinedIcon />
                      </Link>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
        </Row>
      </div>
    </div>
  );
};

export default PopularTest;
